






import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "FileImageView",
  props: {
    fileName: { type: String, required: true },
    isPublic: { type: Boolean, default: false },
  },
  computed: {
    separatedFileName(): { name: string; type: string } {
      const carsArr = this.fileName.split(".");
      const type = `.${carsArr[carsArr.length - 1]}`;
      const name = carsArr.splice(0, carsArr.length - 1).join(" ");

      return { name, type };
    },
  },
});
